/***
 * Created on 2023/10/19
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React, {useEffect, useState} from 'react';
import {getAppCDNUrl} from 'common/ServiceCommon';
import ServiceAppItem from "./service_app_item";
import {useTranslation} from "react-i18next";

const ExcludeServiceForChina = ['Hybrid Backup Center', 'Software Store', 'Qmiix', 'Service Portal']


function AccountActivated(props) {
    const { t } = useTranslation();
    const service_apps = localStorage.getItem('service_apps');
    const [serviceItems, setServiceItems] = useState(service_apps ? JSON.parse(service_apps) : null);

    const getServiceItems = async () => {
        try {
            const response = await fetch(`${getAppCDNUrl()}/cloud_app/app_info.json`);
            if (!response.ok) {
                throw new Error('Api Request Error', {
                    cause: response
                });
            }
            const res = await response.json();
            setServiceItems(res);
            return res;
        } catch (err) {
            if (err?.cause) {
                console.log(err.cause);
            }
            throw new Error(err);
        }
    }

    useEffect(() => {
        if (!serviceItems) {
            getServiceItems();
        }
    }, []);

    return (
        <section className="common-page-wrapper">
            <div className="common-page-header">{t('@myQNAPcloud account activated@')}</div>
            <div className="common-page-body">
                <div className="font-medium text-18 mb-16">{t('@Congratulations!@')}</div>
                <p>{t('@Your myQNAPcloud account have completed the registration. Please sign in to manage your account profile.@')}</p>
                <p>{t('@QNAP provides a wide range of products and services for you. We invite you to pick topics of interest to receive more relevant and personalized content and learn how QNAP can help you achieve your goals!@')}
                    <a href="/signin?state=%2F%23%2Fmy-interests">» {t('@Choose my personalized content@')}</a></p>
                <p>{t('@You may use and enjoy below services which provided by QNAP@')}</p>
                <div className="common-info-grid">
                    <ul className="common-info-grid__services-grid">
                        {
                            serviceItems?.apps?.filter(app => !ExcludeServiceForChina.includes(app.title)).map((item, index )=> <ServiceAppItem item={item} key={index}/>)

                        }

                    </ul>
                </div>
            </div>
        </section>
    );
}

export default AccountActivated;